import React from 'react';

/**
 * BillingDetailsFilled - Displays billing information with edit capability
 * 
 * @param {Object} billingData - Billing information object
 * @param {string} billingData.billingAddress - Full billing address
 * @param {string} billingData.companyName - Company name
 * @param {string} billingData.phoneNumber - Phone number
 * @param {string} billingData.purchaseOrderNumber - Purchase order number
 * @param {string} billingData.taxNumber - Tax number
 * @param {Function} onEdit - Callback when edit button is clicked
 */
const BillingDetailsFilled = ({ billingData, onEdit }) => {
    const {
        billingAddress = '',
        companyName = '',
        phoneNumber = '',
        purchaseOrderNumber = '',
        taxNumber = ''
    } = billingData || {};

    return (
        <div className="bg-white rounded-lg p-0 max-w-2xl">
            {/* Header */}
            {/* Header */}
            <div className="flex items-center justify-between mb-[4px] max-[576px]:flex-col max-[576px]:items-start max-[576px]:gap-4">
                <h2 className="font-aleo font-semibold text-[26px] leading-[32px] text-[#182230] w-[462px] max-[576px]:w-full max-[576px]:max-w-[350px]">Billing details</h2>
                <button
                    onClick={onEdit}
                    className="w-[62px] h-[26px] flex items-center justify-center gap-[6px] bg-white border border-[#D0D5DD] rounded-[8px] px-[8px] py-[6px] text-[#344054] hover:bg-gray-50 transition-colors"
                >
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6.50004 2.16669L9.83337 5.50002M1.93922 10.395L2.34836 8.52554C2.39693 8.30366 2.42121 8.19272 2.46419 8.09068C2.50239 8.00003 2.55225 7.91428 2.61254 7.83561C2.6804 7.74706 2.76228 7.67156 2.92603 7.52055L9.1667 1.76669C9.62694 1.34235 10.3731 1.34235 10.8334 1.76669C11.2936 2.19102 11.2936 2.87895 10.8334 3.30329L5.0795 9.05732C4.9285 9.20829 4.85299 9.28378 4.76444 9.35164C4.68577 9.41193 4.60002 9.46179 4.50937 9.49999C4.40733 9.54297 4.29639 9.56726 4.07451 9.61582L2.20504 10.025C1.86018 10.1005 1.51682 9.77123 1.59229 9.42637L1.93922 10.395Z"
                            stroke="#344054"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="font-noto font-bold text-[12px] leading-[16px]">Edit</span>
                </button>
            </div>

            <p className="font-noto font-normal text-[14px] text-[#667085] leading-[24px] mb-[32px] w-[462px] max-[576px]:w-full max-[576px]:max-w-[350px]">
                Choose your payment method to complete your purchase.
            </p>

            {/* Your Details Section */}
            <h3 className="font-noto font-semibold text-[18px] text-[#182230] mb-[26px]">Your details</h3>

            <div className="w-full md:w-[588px] h-auto md:h-[290px] grid grid-cols-1 md:grid-cols-2 gap-[20px] md:gap-[24px] max-[576px]:w-full max-[576px]:max-w-[350px]">
                {/* Left Column */}
                <div className="space-y-[20px]">
                    {/* Billing Address */}
                    <div>
                        <label className="block font-noto font-normal text-[12px] leading-[18px] text-[#667085] mb-[10px] m-0 p-0">
                            Billing address
                        </label>
                        <p className="font-noto font-normal text-[16px] leading-[24px] text-[#667085] whitespace-pre-line m-0 p-0">
                            {billingAddress || '-'}
                        </p>
                    </div>
                </div>

                {/* Right Column */}
                <div className="space-y-[20px]">
                    {/* Company Name */}
                    <div>
                        <label className="block font-noto font-normal text-[12px] leading-[18px] text-[#667085] mb-[10px] m-0 p-0">
                            Company name
                        </label>
                        <p className="font-noto font-normal text-[16px] leading-[24px] text-[#667085] m-0 p-0">
                            {companyName || '-'}
                        </p>
                    </div>

                    {/* Phone Number */}
                    <div>
                        <label className="block font-noto font-normal text-[12px] leading-[18px] text-[#667085] mb-[10px] m-0 p-0">
                            Phone number
                        </label>
                        <p className="font-noto font-normal text-[16px] leading-[24px] text-[#667085] m-0 p-0">
                            {phoneNumber || '-'}
                        </p>
                    </div>

                    {/* Purchase Order Number */}
                    <div>
                        <label className="block font-noto font-normal text-[12px] leading-[18px] text-[#667085] mb-[10px] m-0 p-0">
                            Purchase order number
                        </label>
                        <p className="font-noto font-normal text-[16px] leading-[24px] text-[#667085] m-0 p-0">
                            {purchaseOrderNumber || '-'}
                        </p>
                    </div>

                    {/* Tax Number */}
                    <div>
                        <label className="block font-noto font-normal text-[12px] leading-[18px] text-[#667085] mb-[10px] m-0 p-0">
                            Tax number
                        </label>
                        <p className="font-noto font-normal text-[16px] leading-[24px] text-[#667085] m-0 p-0">
                            {taxNumber || '-'}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillingDetailsFilled;
